import axios from "axios";
import { queryParams } from "../../../../utils/queryParams";

const locations = axios.create({
  baseURL: queryParams.apiVersion + "settings/locations_list"
});

const presets = axios.create({
  baseURL: queryParams.apiVersion + "settings/user_locations_presets"
});

export const api = {
  getFilters(params) {
    return locations.get("", params);
  },
  createShortUrl(params) {
    return locations.post("/create_short_url", params);
  },
  getFiltersByShortUrl(params) {
    return locations.get("/locations_by_short_url", params);
  },
  getPresets(params) {
    return presets.get("", params);
  },
  createPreset(params) {
    return presets.post("", params);
  },
  editPreset(id, params) {
    return presets.put(`/${id}`, params);
  },
  removePreset(id) {
    return presets.delete(`/${id}`);
  }
};
